var exports = {
  "k": "xcc377c0b--470abf--container",
};

module.exports = exports;
